import { Controller } from '@hotwired/stimulus'

// Shared public navbar: mega menu toggle, mobile drawer, outside-click close,
// and nav-theme swap when the CTA section scrolls into view. Attach to the
// top-level wrapper of any public flamingOS landing page.
export default class extends Controller {
  static targets = ['nav', 'mega', 'drawer', 'hamburger', 'cta']

  connect () {
    this.#observeNavTheme()
  }

  disconnect () {
    this.navThemeObserver?.disconnect()
    document.body.style.overflow = ''
  }

  // ── Mega menu ──

  toggleMega ({ currentTarget }) {
    const mega = currentTarget.nextElementSibling
    const wasOpen = mega?.classList.contains('open')

    this.closeMegas()
    if (!wasOpen && mega) mega.classList.add('open')
  }

  closeMegas () {
    this.megaTargets.forEach(m => m.classList.remove('open'))
  }

  closeMenuOnOutsideClick ({ target }) {
    if (!target.closest('.nav-item')) this.closeMegas()
  }

  // ── Mobile drawer ──

  toggleDrawer () {
    if (!this.hasDrawerTarget) return

    const opening = !this.drawerTarget.classList.contains('open')
    this.drawerTarget.classList.toggle('open', opening)
    this.hamburgerTarget.classList.toggle('open', opening)
    document.body.style.overflow = opening ? 'hidden' : ''
  }

  closeDrawer () {
    if (!this.hasDrawerTarget || !this.drawerTarget.classList.contains('open')) return
    this.toggleDrawer()
  }

  // ── Nav theme when CTA is in view ──

  #observeNavTheme () {
    if (!this.hasCtaTarget || !this.hasNavTarget) return

    this.navThemeObserver = new IntersectionObserver(entries => {
      entries.forEach(e => this.navTarget.classList.toggle('nav-on-cta', e.isIntersecting))
    }, { threshold: 0.15 })

    this.navThemeObserver.observe(this.ctaTarget)
  }
}
